/** Riga della tabella recipes (supabase/migrations/20261028020000_recipes.sql). */
export interface Recipe {
  id: string;
  slug: string;
  title: string;
  summary: string;
  image_url: string | null;
  ingredients: string[];
  /** Procedimento in HTML dall'editor formattato. */
  description: string;
  servings: number | null;
  prep_minutes: number | null;
  cook_minutes: number | null;
  product_id: string | null;
  published: boolean;
  created_at: string;
  updated_at: string;
}

export type RecipeInput = Omit<Recipe, 'id' | 'created_at' | 'updated_at'>;

export const RECIPE_SELECT =
  'id, slug, title, summary, image_url, ingredients, description, servings, prep_minutes, cook_minutes, product_id, published, created_at, updated_at';

/** "Torta di mele al miele!" -> "torta-di-mele-al-miele" */
export const recipeSlug = (title: string) =>
  title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 80)
    .replace(/-$/, '');

/** 95 -> "1 h 35 min" */
export function minutesLabel(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (!h) return `${m} min`;
  return m ? `${h} h ${m} min` : `${h} h`;
}
